import store from "./index";


export const checkPermissionsFor = (method, forcedPermissions) => {
    const permissionMethods = store.getState().auth.permissions;
    const permissionsToCheck = forcedPermissions || permissionMethods;
    return permissionsToCheck?.length ? permissionsToCheck.includes(method) : false;
};